import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '@repo/ui/components/button';
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@repo/ui/components/dialog';

export function AppUpdateModal() {
	const {
		offlineReady: [_, setOfflineReady],
		needRefresh: [needRefresh, setNeedRefresh],
		updateServiceWorker,
	} = useRegisterSW({});

	const close = () => {
		setOfflineReady(false);
		setNeedRefresh(false);
	};

	return (
		<Dialog open={needRefresh}>
			<DialogContent className='sm:max-w-[425px] [&>button]:hidden'>
				<DialogHeader>
					<DialogTitle>New version available</DialogTitle>
					<DialogDescription>
						Click "Reload" to refresh the app and get the latest features and fixes.
					</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<DialogClose
						render={
							<Button variant='outline' onClick={close}>
								Cancel
							</Button>
						}
					/>
					<Button type='submit' onClick={() => updateServiceWorker(true)}>
						Reload
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
